import React from 'react';

const Premium = () => {
  return (
    <section className="bg-[#2a081a] text-[#ebe2db] py-16 px-4 sm:px-10">
      <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center">
        {/* Text Content */}
        <div>
          <h2 className="text-xl sm:text-4xl font-cinzel text-[#e0c3b5] mb-6 leading-snug">
            Premium Craftsmanship.
            <br />
            Accessible Luxury.
            <br />
            Made to Last.
          </h2>

          <p className="text-sm sm:text-base leading-relaxed text-[#d8cbc4]">
            Every Zarviya creation carries a story — inspired by India’s timeless heritage and
            designed for today’s modern elegance. Meticulous attention to detail, handpicked
            designs, and enduring finishes ensure that each piece resonates with beauty and grace,
            from the very first wear to countless occasions ahead.
          </p>
          <p className="mt-6 font-semibold text-[#e0c3b5] uppercase tracking-wide text-sm">
            Crafted to be worn, remembered, and cherished.
          </p>
        </div>

        {/* Image */}
        <div>
          <video
            src="https://res.cloudinary.com/dubbklkla/video/upload/v1755377879/VN20250803_150819_zldpcg.mp4"
            className="rounded-xl shadow-lg border border-[#b09287]/30"
            autoPlay
            loop
            muted
            playsInline
            preload="auto" // 👈 key for caching/preloading
          />
        </div>
      </div>
    </section>
  );
};

export default Premium;
